import { DvCheckboxCellRenderer, DvToolbarAction } from '@devinco/ui/grid';
import { Injectable, inject } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { ToolbarActionsService } from '@features/vt-grid/services/toolbar-actions.service';
import { TranslateService } from '@ngx-translate/core';
import { ColDef, ValueFormatterParams } from 'ag-grid-community';
import { TripExpenseDto } from '@pages/trips-page/components/trip-expenses-tab/interfaces';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';

@Injectable()
export class ExpensesGridService {
  private readonly translate = inject(TranslateService);
  private toolbarActionService = inject(ToolbarActionsService);

  getColumnDefs: ColDef<TripExpenseDto>[] = [
    {
      headerName: 'Grid.Id',
      field: 'TripExpenseID',
      type: [ColumnType.Id],
      filter: 'agNumberColumnFilter',
      hide: true,
    },
    {
      headerName: 'Grid.Description',
      field: 'TranslationKey',
      type: [ColumnType.TranslatedText],
      valueFormatter: (params: ValueFormatterParams) => {
        return params.value || params.data?.Description;
      },
    },
    {
      headerName: 'Grid.Description',
      field: 'Description',
      type: [ColumnType.Text],
      hide: true,
      suppressColumnsToolPanel: true,
    },
    {
      headerName: 'Grid.DistQty',
      field: 'Quantity',
      type: [ColumnType.NumberText],
    },
    {
      headerName: 'ExpenseGrid.Rate',
      field: 'Rate',
      type: [ColumnType.Number],
    },
    {
      headerName: 'Grid.Amount',
      field: 'Amount',
      type: [ColumnType.Number],
    },
    {
      headerName: 'Grid.Comment',
      field: 'Comment',
      type: [ColumnType.Text],
      width: 150,
    },
    {
      headerName: 'Grid.PersonalTaxable',
      field: 'IsPrivateTaxable',
      type: [ColumnType.Checkbox],
    },
    {
      headerName: 'ExpenseGrid.RateEnabled',
      field: 'RateEnabled',
      type: [ColumnType.Checkbox],
    },
    {
      headerName: 'ExpenseGrid.ExpenseSettingId',
      field: 'ExpenseSettingID',
      type: [ColumnType.Number],
      hide: true,
      flex: 1,
    },
    {
      headerName: 'ExpenseGrid.TripDistanceConnection',
      field: 'TripDistanceConnection',
      type: [ColumnType.Boolean],
      cellRenderer: DvCheckboxCellRenderer,
      hide: true,
      flex: 1,
    },
    {
      headerName: 'ExpenseGrid.LastEdited',
      field: 'LastEdited',
      type: [ColumnType.DateTime],
      hide: true,
    },
    {
      headerName: 'ExpenseGrid.LastEditedBy',
      field: 'LastEditedBy',
      type: [ColumnType.Text],
      hide: true,
    },
  ];

  getToolbarActions(
    editAction: (isAdding: boolean) => void,
    addAction: (isAdding: boolean) => void
  ): DvToolbarAction[] {
    const { deleteSelectedRow } = this.toolbarActionService;
    return [
      ...getStandardActionPreset(),
      {},
      {
        icon: 'delete',
        clickFn: deleteSelectedRow,
        disabled: true,
        tooltip: this.translate.instant('Grid.Delete'),
      },
      {
        icon: 'edit',
        clickFn: () => {
          editAction(false);
        },
        disabled: true,
        tooltip: this.translate.instant('Grid.Edit'),
      },
      {
        icon: 'add_box',
        clickFn: () => {
          addAction(true);
        },
        disabled: true,
        tooltip: this.translate.instant('Grid.Add'),
      },
    ];
  }
}
